import { useCallback, useEffect } from "react";
import { batch } from "react-redux";

import {
    DRAWER_ACTIONS,
    useDrawerDispatch,
    useDrawerState,
} from "@hmn/coolinarika-web-core/context/Drawer";
import { useUser } from "@hmn/coolinarika-web-core/hooks";

import { DrawerBody, DrawerSeparator, DrawerTextBlock } from "../Drawer";
import { DefaultFallback, withErrorBoundary } from "../ErrorBoundary";
import { AuthFormLogin, AuthJoinCta, AuthNotification, AuthSocial } from "./components";
import { notificationUID } from "./uids";

const { LOGIN: LOGIN_NOTIFICATION_UID } = notificationUID;

const Login = () => {
    const { isLoggedIn } = useUser();
    const dispatch = useDrawerDispatch();
    const { onSuccessDrawer } = useDrawerState();

    const getIntroContent = () => {
        const blockTitle = "Prijavi se na Coolinariku!";
        const blockDescription =
            // eslint-disable-next-line max-len
            "Iskustvo korištenja puno je bolje za prijavljene korisnike. Moći ćeš spremati recepte, kreirati vlastite i reći nam što voliš ili ne smiješ jesti.";
        return {
            title: blockTitle,
            description: blockDescription,
        };
    };

    const handleSuccessCallback = useCallback(() => {
        if (onSuccessDrawer) {
            batch(() => {
                dispatch({
                    type: DRAWER_ACTIONS.OPEN_DRAWER,
                    payload: {
                        drawerType: onSuccessDrawer,
                    },
                });
                dispatch({
                    type: DRAWER_ACTIONS.SET_ON_SUCCESS_DRAWER,
                    payload: {
                        onSuccessDrawer: false,
                    },
                });
            });
        } else {
            dispatch({
                type: DRAWER_ACTIONS.CLOSE_DRAWER,
                payload: {
                    drawerType: null,
                },
            });
        }
    }, [dispatch, onSuccessDrawer]);

    useEffect(() => {
        if (isLoggedIn) {
            handleSuccessCallback();
        }
    }, [isLoggedIn]);

    return (
        <>
            <DrawerBody>
                <DrawerTextBlock
                    title={getIntroContent().title}
                    description={getIntroContent().description}
                />
                <AuthSocial onLoginSuccess={handleSuccessCallback} />
                <DrawerSeparator text="ili upiši svoje podatke" />
                <AuthFormLogin onLoginSuccess={handleSuccessCallback} />
                <AuthJoinCta />
            </DrawerBody>
            <AuthNotification uid={LOGIN_NOTIFICATION_UID} />
        </>
    );
};

export default withErrorBoundary(Login, {
    FallbackComponent: (err) => <DefaultFallback err={err} />,
});
